import { flow, makeObservable } from 'mobx';
import { GlobalStore, FormStore } from '@roc/feature-app-core';
import { LoanStore } from '@roc/feature-loans';
import { DocumentStore } from '../../documentStore';
import { PostClosingConditionService } from '../../../services/documentForms/postClosingConditionService';

const REQUIRED_FIELD = 'This field is required.';

const form = {
  fields: {
    level: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_FIELD,
    },
    description: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_FIELD,
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class CreatePostClosingConditionStore extends FormStore {
  globalStore: GlobalStore;
  loanStore: LoanStore;
  documentStore: DocumentStore;
  postClosingConditionService: PostClosingConditionService;

  constructor(loanStore: LoanStore, documentStore: DocumentStore, globalStore: GlobalStore) {
    super(form, globalStore);
    this.loanStore = loanStore;
    this.documentStore = documentStore;
    this.globalStore = globalStore;
    this.postClosingConditionService = new PostClosingConditionService();

    makeObservable(this, {
      submit: flow,
    });
  }

  resetStore() {
    this.reset();
  }

  *submit(taskId: number, _taskTitle: string, onSuccess: () => void) {
    try {
      this.runFormValidationWithMessage();
      if (this.form.meta.isValid) {
        const data = this.getFormValues();
        yield this.postClosingConditionService.createCondition(taskId, data.level, data.description);
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Post-closing condition saved successfully.',
        });
        this.resetStore();
        onSuccess();
      }
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while saving post-closing condition',
      });
    }
  }
}
